module.exports = __webpack_public_path__ + "img/allthebridge1.66f65647.jpg";